var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"warnInfo"},[_vm._v("本平台为非涉密平台，严禁处理、传输国家秘密")]),_c('table-box'),(_vm.$route.meta.pageTitle)?_c('nav-title'):_vm._e(),(_vm.popShow)?_c('pop-box'):_vm._e(),_c('transition',{attrs:{"name":_vm.transitionName}},[(!_vm.popShow)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }